import React, { Component } from 'react'
import { number, shape } from 'prop-types'

import isDOMAvailable from 'utils/isDOMAvailable'

import {
  ResponsiveContainer,
  RadarChart,
  Radar,
  PolarGrid,
  PolarAngleAxis,
  PolarRadiusAxis,
  Tooltip,
} from 'recharts'

class RiasecChart extends Component {
  componentDidMount() {
    isDOMAvailable &&
      // need to be inspected again
      setTimeout(() => {
        document
        .querySelector('.recharts-polar-angle-axis-tick:nth-child(4) tspan') &&
          document
            .querySelector('.recharts-polar-angle-axis-tick:nth-child(4) tspan')
            .setAttribute('dy', '1em')
      }, 300)
  }

  render() {
    const { ratioData } = this.props
    const chartData = 'RIASEC'.split('').map(key => ({
      label: key,
      score: Math.floor(ratioData[key].value),
      maxScore: 100,
    }))
    return (
      <div className="riasec-chart">
        <ResponsiveContainer height={400}>
          <RadarChart
            margin={{
              top: 0,
              right: 0,
              bottom: 0,
              left: 0,
            }}
            data={chartData}
          >
            <PolarGrid
              stroke="#00beff"
              stroke-dasharray="4"
            />
            <PolarAngleAxis
              tickLine={false}
              dataKey="label"
              stroke="#00beff"
              strokeWidth="4"
            />
            <PolarRadiusAxis
              angle={30}
              domain={[0, 100]}
              fillOpacity={0}
              strokeOpacity={0}
              tickCount={2}
            />
            <Radar
              name="RIASEC"
              dataKey="score"
              stroke="#00beff"
              strokeWidth="2"
              fill="#00beff"
              fillOpacity={100}
            />
            <Tooltip />
          </RadarChart>
        </ResponsiveContainer>
        <style jsx global>
          {`
            .riasec-chart {
              width: 100%;
              height: 100%;
              .recharts-polar-angle-axis-tick {
                tspan {
                  font-size: 16px;
                }
                text {
                  fill: #2440a4;
                  font-weight: bold;
                }
              }
              line {
                stroke-dasharray: 4;
              }
            }
          `}
        </style>
      </div>
    )
  }
}

const valueProp = shape({
  value: number,
})

RiasecChart.propTypes = {
  ratioData: shape({
    R: valueProp,
    I: valueProp,
    A: valueProp,
    S: valueProp,
    E: valueProp,
    C: valueProp,
  }),
}

export default RiasecChart
